<template>
  <AppModal
    :show="showModal"
    do-not-close-on-outside-click
    @close="showModal = false"
  >
    <h3>{{ $t("subscriptionModal.title") }}</h3>
    <p>{{ $t("subscriptionModal.text") }}</p>

    <SubscribeForm
      :disabled="isSaving"
      :settings="props.settings"
      :has-phone="props.hasPhone"
      @submit="onSubmit($event)"
    />
  </AppModal>
</template>

<script setup lang="ts">
import AppModal from "@/components/app-modal.vue";
import { onMounted, ref } from "vue";
import { SubscribeFormData, SubscribeSettings } from "./models";
import SubscribeForm from "./subscribe-form.vue";
import { useToast } from "../../utils/use-toast";
import {
  updateEmailNotification,
  updateNewsletterNotification,
  updateSMSNotification,
} from "../settings/store";

const props = defineProps<{
  subscriptionGuid: string;
  settings?: SubscribeSettings;
  hasPhone?: boolean;
}>();

const showModal = ref(true);
const isSaving = ref(false);
const { success } = useToast();

const onSubmit = async (data: SubscribeFormData) => {
  isSaving.value = true;

  try {
    if (data.email !== !!props.settings?.reservation_reminder_email) {
      await updateEmailNotification(data.email, {
        guid: props.subscriptionGuid,
      });
    }

    if (data.sms !== !!props.settings?.reservation_reminder_sms) {
      await updateSMSNotification(data.sms, data.phone, {
        guid: props.subscriptionGuid,
      });
    }

    if (data.newsletter !== !!props.settings?.newsletter) {
      await updateNewsletterNotification(data.newsletter, {
        guid: props.subscriptionGuid,
      });
    }
    success("subscriptionModal.success");
    showModal.value = false;
  } finally {
    isSaving.value = false;
  }
};

onMounted(() => {
  window.history.replaceState({}, "", "/");
});
</script>
